// Centralized public-site vs. application-site context. The same Vue build/source
// tree is served on both hostnames (theskyspeaks.* and app.theskyspeaks.*); this is
// the single place that inspects the browser hostname so no component needs its own
// `window.location.hostname === ...` check.
//
// VITE_SITE_ORIGIN / VITE_APP_ORIGIN can override the defaults below via
// client/.env.local (dev) or client/.env.production (prod) -- see
// _infra/_docs/runbooks/local-subdomain-dev.md. Sensible defaults are baked in so this
// works out of the box without requiring any .env file to exist.
const DEFAULT_SITE_ORIGIN = import.meta.env.PROD
  ? 'https://theskyspeaks.com'
  : 'https://theskyspeaks.test';
const DEFAULT_APP_ORIGIN = import.meta.env.PROD
  ? 'https://app.theskyspeaks.com'
  : 'https://app.theskyspeaks.test';

export const SITE_ORIGIN = import.meta.env.VITE_SITE_ORIGIN || DEFAULT_SITE_ORIGIN;
export const APP_ORIGIN = import.meta.env.VITE_APP_ORIGIN || DEFAULT_APP_ORIGIN;

function hostnameOf(origin) {
  try {
    return new URL(origin).hostname;
  } catch {
    return '';
  }
}

function currentHostname() {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

// Determined once from the actual browser hostname (not build mode -- one build
// serves both hosts). Defaults to the application context, which preserves today's
// only existing behavior for plain `localhost` dev with no reverse proxy in front of
// it; only the hostname that explicitly matches the configured public site origin
// switches to the public-site context.
export const isPublicSite = currentHostname() === hostnameOf(SITE_ORIGIN);
export const isAppSite = !isPublicSite;

export function publicUrl(path = '/') {
  return `${SITE_ORIGIN}${path}`;
}

export function appUrl(path = '/') {
  return `${APP_ORIGIN}${path}`;
}
